export const handleFetchSuccess = (state, payload) => ({
    ...state,
    list: payload.data,
    listFetching: false,
    listPagination: {
        current_page: payload.current_page || 1,
        last_page: payload.last_page || 1,
    },
});
